import React, { useState, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { colors } from '@/globalStyles';
import { MIDDLE, CENTER } from '@/constants';
import { SymbolEntity, getAssetsFullPath } from '@/helpers';

import { GridContainer, Label } from '@/components/SideBar/styles';

import SymbolFontSelectMenu from '@/components/Menus/SymbolFontSelectMenu';
import IconExpand from '@/icons/icon-expand.svg';
import IconExpandClose from '@/icons/icon-expand-close.svg';

import {
  SelectButton,
  ListContainer,
  SymbolImageContainer,
  Icon,
} from './styles';

const InsertSymbolFormWebComponent = (props) => {
  const { symbolsList, symbolFontParams, symbolFont: currentSymbolFont, symbol = null, onChange, verticalAlignment, horizontalAlignment } = props;
  
  const [isLibModalOpen, setLibModalOpen] = useState(false);
  const [symbolFont, setSymbolFont] = useState(currentSymbolFont);
  const [anchorElSymbolFontSelect, setAnchorElSymbolFontSelect] = useState(null);
  const symbolLibrariesList = useMemo(() => (
    symbolFontParams.map(({ name, labelKey, labelDefault }) => ({
      value: name,
      label: <FormattedMessage id={"assets.fonts." + labelKey} defaultMessage={labelDefault} />
    }))
  ), [symbolFontParams]);
  const symbolFontLabel = useMemo(() => {
    const symbolFontParam = symbolFontParams.find(f => f.name === symbolFont);
    return symbolFontParam ? (<FormattedMessage id={"assets.fonts." + symbolFontParam.labelKey} defaultMessage={symbolFontParam.labelDefault} />) : symbolFont;
  }, [symbolFontParams, symbolFont]);

  const onSymbolLibSelect = (symbolObj) => {
    if (symbolObj !== symbolFont) {
      setSymbolFont(symbolObj);
    }
  }

  const onSymbolSelect = unicode => {
    onChange({ symbol: { unicode, horizontalAlignment: horizontalAlignment || CENTER, verticalAlignment: verticalAlignment || MIDDLE }, symbolFont });
  }

  const handleDragStart = (unicode) => {
    SymbolEntity.setSymbol({ symbol: { unicode }, symbolFont });
  }
  
  const handleClickSymbolFontSelect = (event) => {
    setAnchorElSymbolFontSelect(event.currentTarget);
    setLibModalOpen(true);
  };

  return (
    <>
      <SymbolFontSelectMenu
        key="SymbolFontSelectMenu"
        anchorEl={anchorElSymbolFontSelect}
        open={isLibModalOpen}
        setOpen={setLibModalOpen}
        selected={symbolFont}
        onSelect={onSymbolLibSelect}
        list={symbolLibrariesList}
      />

      <GridContainer gridTemplateColumns="1fr" gridTemplateRows="max-content 50px max-content">
        <Label>
          <FormattedMessage id="app.editor.sideMenu.panelLabel.symbolLibrary" defaultMessage="Symbol library" />
        </Label>
        <SelectButton onClick={(e) => handleClickSymbolFontSelect(e)} >
          <Label color={isLibModalOpen ? colors.primary : colors.black}>
            {symbolFontLabel}
          </Label>
          <Icon src={isLibModalOpen? IconExpandClose : IconExpand} />
        </SelectButton>
        <ListContainer>
          {symbolsList[symbolFont].glyphs.map(item => (
            <SymbolButtonWebComponent
              key={`${symbolFont}-${item.unicode}`}
              item={item}
              selected={item.unicode === symbol?.unicode && symbolFont === currentSymbolFont}
              onClick={onSymbolSelect}
              handleDragStart={handleDragStart}
            />
          ))}
        </ListContainer>
      </GridContainer>
    </>
  );
};

export default React.memo(InsertSymbolFormWebComponent);

export const SymbolButtonWebComponent = React.memo((props) => {
  const { item, selected, onClick, handleDragStart } = props;
  const src = getAssetsFullPath(item.url);
  const unicode = item.unicode;

  return (
    <SymbolImageContainer
      className={selected ? 'selected' : ''}
      width="100%"
      height="100%"
      src={src}
      selected={selected}
      onClick={onClick.bind(null, unicode)}
      onDragStart={handleDragStart.bind(null, unicode)}
    />
  );
});
